import React from 'react';
import './Team.css';
import TeamHero from '../components/team/TeamHero';
import TeamValueGrid from '../components/team/TeamValueGrid';
import TrackRecord from '../components/team/TrackRecord';
import LeadershipGrid from '../components/team/LeadershipGrid';
import CompliancePanel from '../components/team/CompliancePanel';
import TeamCTA from '../components/team/TeamCTA';
import Footer from '../unAuth/Components/footer';

const Team = ({ onLearnMore }) => {
  return (
    <div className="team-page">
      <TeamHero />
      <TeamValueGrid />
      <TrackRecord />
      <LeadershipGrid />
      <CompliancePanel />
      <TeamCTA onLearnMore={onLearnMore} />
      <Footer />
    </div>
  );
};

export default Team;
